// extracted by mini-css-extract-plugin
module.exports = {"contents":"core_contents__1hPBb"};